function sourceTerminalChange(_sourceTerminalId) {
  var terminalIdRegEx = new RegExp('/terminals/([0-9]+)/risk_filters/copy');
  var terminalId = window.location.pathname.match(terminalIdRegEx)[1];
  var loadFiltersUrl = '/terminals/' + _sourceTerminalId + '/load_risk_filters';
  $.ajax({
    type: 'POST',
    url: window.location.pathname.replace(terminalIdRegEx, loadFiltersUrl),
    dataType: 'html',
    data: {
      terminal_id: terminalId
    }
  }).done(function (response) {
    $('#risk_filters.for-copy').html($.parseHTML(response));
  });
}

function listenForSourceTerminalChange() {
  $('#filters_source_terminal_id').on('change', function () {
    sourceTerminalChange($(this).val());
  });
}

var LoadTerminalRiskFilters = {
  listenForSourceTerminalChange: listenForSourceTerminalChange
};
export default LoadTerminalRiskFilters;